// Module
var code = "<div class=\"socialbar__button socialbar__button--peoplesearch\" ng-click=\"hmenu.peoplesearchHandler()\"> <div class=\"socialbar__button__button\"> <dynicon icon=\"'peoplesearch'\" x=\"'20px'\" y=\"'20px'\" style=\"opacity:.5;margin-top:3px\"></dynicon> </div> <div class=\"socialbar__button__tooltip\"> People Search </div> </div>";
// Exports
module.exports = code;